import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Button } from 'antd';
import { formatDate } from '../../utils/formatDate';
import {
  fetchAdminTopupsAC,
  adminTopupsDataSelector,
  fetchAdminTopupsErrorSelector,
  isFetchingAdminTopupsSelector,
  totalTopupSelector,
  currentPageSelector,
  pageSizeSelector,
} from '../../apiCalls/adminTopups/list';
import ErrorMessage from '../shared/ErrorMessage';
import Status from '../shared/Status';
import DataTable from '../shared/DataTable';
import PageTitle from '../shared/PageTitle';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Date',
    dataIndex: 'created_at',
    render: value => formatDate(value),
  },
  {
    title: 'User',
    dataIndex: ['user', 'name'],
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    render: value => `RM${value}`,
    align: 'right',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: value => <Status status={value} />,
  },
  {
    title: 'Invoice',
    dataIndex: 'invoice',
    align: 'center',
    render: ({ origin_url }) =>
      origin_url ? (
        <a href={origin_url} target="_blank" rel="noopener noreferrer">
          <i className="fas fa-paperclip" />
        </a>
      ) : (
        '-'
      ),
  },
  {
    title: 'Action',
    key: 'action',
    render: (text, record) => {
      const queryString = new URLSearchParams(window.location.search);

      return (
        <Button.Group>
          <Button>
            <Link to={`/payment/topups/${record.id}?${queryString}`}>
              Detail
            </Link>
          </Button>
        </Button.Group>
      );
    },
  },
];

const AdminTopups = ({
  withdrawalRequests,
  fetchAdminTopups,
  loading,
  error,
  history,
  ...others
}) => {
  const location = useLocation();
  const params = queryString.parse(location.search, { arrayFormat: 'bracket' });

  useEffect(() => {
    fetchAdminTopups({ filter: params });
    // eslint-disable-next-line
  }, [location, fetchAdminTopups]);

  return (
    <>
      <PageTitle content="Topup Records" />
      {error && <ErrorMessage />}
      <DataTable
        dataSource={withdrawalRequests}
        dataFetcher={fetchAdminTopups}
        loading={loading}
        filters={{ filter: params }}
        columns={columns}
        {...others}
      />
    </>
  );
};

const connectToRedux = connect(
  state => ({
    withdrawalRequests: adminTopupsDataSelector(state),
    loading: isFetchingAdminTopupsSelector(state),
    error: fetchAdminTopupsErrorSelector(state),
    totalItems: totalTopupSelector(state),
    currentPage: currentPageSelector(state),
    pageSize: pageSizeSelector(state),
  }),
  {
    fetchAdminTopups: fetchAdminTopupsAC,
  }
);

export default connectToRedux(AdminTopups);
